import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import { Select, Button } from 'antd';
import { connect } from 'react-redux';
import { formatEventTypes } from '../../../core/utils/functions';
import { Erase } from '@carbon/icons-react';
import * as eventsActions from '../../../core/events/eventsActions';
import * as assetActions from '../../../core/asset/assetActions';
import DateRangePicker from '../../../components/DateRangePicker';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

dayjs.extend(customParseFormat);

class AssetEventHistoryFilterForm extends Component {
    constructor(props) {
        super(props);
        let currentAssetFilters = null;
        if (props?.assetViewEventFilters?.length) {
            const matches = props.assetViewEventFilters.filter(f => parseInt(f.assetId) === parseInt(props.assetId));
            if (matches?.length) {
                currentAssetFilters = matches[0]?.filters;
            }
        }
        this.state = { currentAssetFilters };
    }

    componentDidUpdate(prevProps) {
        const { assetViewEventFilters, assetId } = this.props;

        if (prevProps.assetViewEventFilters !== assetViewEventFilters) {
            let currentAssetFilters = null;
            if (assetViewEventFilters?.length) {
                const matches = assetViewEventFilters.filter(f => parseInt(f.assetId) === parseInt(assetId));
                if (matches?.length) {
                    currentAssetFilters = matches[0]?.filters;
                }
            }
            this.setState({ currentAssetFilters });
        }
    }

    submitForm = (e) => {
        const { onSubmit, form } = this.props;

        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                onSubmit(values);
            }
        });
    };

    render() {
        const {
            form,
            event_types,
            driverList,
            divisionList,
            telematicsRetentionDays,
        } = this.props;
        const { currentAssetFilters } = this.state;

        const { getFieldDecorator, getFieldValue } = form;
        const updatedEventTypes = formatEventTypes(event_types);

        return (
            <Form
                onSubmit={this.submitForm}
                layout="vertical"
            >
                <DateRangePicker
                    getFieldDecorator={getFieldDecorator}
                    getFieldValue={getFieldValue}
                    minDate={dayjs().subtract(telematicsRetentionDays, 'days')}
                    dateFromInitialValue={dayjs(currentAssetFilters?.date_from) || dayjs()}
                    dateToInitialValue={dayjs(currentAssetFilters?.date_to) || dayjs()}
                    dataTestId='asset-details-event-filter_date-range-picker'
                />
                <Form.Item label="Event type">
                    {getFieldDecorator('event_type', { initialValue: currentAssetFilters?.event_type || null })(
                        <Select
                            placeholder="Select event type"
                            allowClear={<Erase size={12} />}
                            showSearch
                            filterOption={(txt, obj) => (obj.props.children.toLowerCase().includes(txt.toLowerCase()))}
                            data-testid='asset-details-event-filter_event-type-select'
                        >
                            <Select.Option value="all">All</Select.Option>
                            {updatedEventTypes.map((eventType, eventTypeIndex) => <Select.Option key={eventTypeIndex} value={eventType.id}>{eventType.key}</Select.Option>)}
                        </Select>,
                    )}
                </Form.Item>
                <Form.Item label="Driver">
                    {getFieldDecorator('driver', { initialValue: currentAssetFilters?.driver || null })(
                        <Select
                            mode="multiple"
                            placeholder="Select driver"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            allowClear
                            showSearch
                            data-testid='asset-details-event-filter_driver-select'
                        >
                            {driverList.map((d) => (
                                <Select.Option
                                    key={d.id}
                                    value={d.id}
                                >
                                    {d.name}
                                </Select.Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="Division">
                    {getFieldDecorator('division', { initialValue: currentAssetFilters?.division || null })(
                        <Select
                            mode="multiple"
                            placeholder="Select Division"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            allowClear
                            showSearch
                            data-testid='asset-details-event-filter_division-select'
                        >
                            {divisionList.map((dl) => <Select.Option key={dl.id} value={dl.id}>{dl.name}</Select.Option>)}
                        </Select>
                    )}
                </Form.Item>
                <div className="mt-2 mb-1 text-center">
                    <Button
                        htmlType="submit"
                        type="primary"
                        data-testid='asset-details-event-filter_filter-btn'
                    >
                        Filter
                    </Button>
                </div>
            </Form>
        );
    }
}

const AssetEventHistory = Form.create({ name: 'event_filter_form' })(AssetEventHistoryFilterForm);

AssetEventHistory.propTypes = {
    assetViewEventFilters: PropTypes.object,
    assetId: PropTypes.number,
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        event_types: state.asset.event_types,
        driverList: state.driver.driverList,
        divisionList: state.asset.divisions,
        telematicsRetentionDays: state.user.userCompany.telematics_retention_days,
        assetViewEventFilters: state.asset.assetViewEventFilters,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...eventsActions,
            ...assetActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AssetEventHistory);
